import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import supportedLocales from 'locales/supported-locales.json';
import { ga } from 'helpers/multitrack';
import { isEmpty } from 'helpers/verify';
import { DisclosureArrow } from 'components/DisclosureArrow/DisclosureArrow';
var languageNames = {
  'fr-FR': 'Français',
  'en-US': 'English (United States)',
  'en-AU': 'English (Australia)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands'
};
export var LocaleSwitcher =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LocaleSwitcher, _React$Component);

  function LocaleSwitcher() {
    var _this;

    _classCallCheck(this, LocaleSwitcher);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocaleSwitcher).call(this));
    _this.localeClicked = _this.localeClicked.bind(_assertThisInitialized(_this));
    _this.onCloseModal = _this.onCloseModal.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LocaleSwitcher, [{
    key: "onCloseModal",
    value: function onCloseModal() {
      var currentLocale = this.getCurrentLocale();
      ga('Footer', 'Click - Close Locale Modal', currentLocale);
      this.props.hideModal('LocaleModal');
    }
  }, {
    key: "getCurrentLocale",
    value: function getCurrentLocale() {
      var currentLocale = this.props.intl.locale;
      return currentLocale;
    }
  }, {
    key: "localeClicked",
    value: function localeClicked() {
      var currentLocale = this.getCurrentLocale();
      this.props.showModal('LocaleModal', {
        currentLocale: currentLocale,
        locales: this.locales(),
        onModalClose: this.onCloseModal,
        onSelect: this.props.updateAccountLocale
      });
      ga('Footer', 'Click - Current Locale', currentLocale);
    }
  }, {
    key: "locales",
    value: function locales() {
      return supportedLocales.map(function (locale) {
        return {
          languageName: languageNames[locale],
          localeKey: locale
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      var currentLocale = this.getCurrentLocale();
      var locales = this.locales();

      if (isEmpty(locales)) {
        return null;
      }

      return React.createElement("span", {
        className: className
      }, children({
        name: languageNames[currentLocale],
        locale: currentLocale,
        onClick: this.localeClicked
      }));
    }
  }]);

  return LocaleSwitcher;
}(React.Component);
LocaleSwitcher.defaultProps = {
  className: 'LocaleSwitcher',
  children: function children(_ref) {
    var locale = _ref.locale,
        onClick = _ref.onClick,
        name = _ref.name;
    return React.createElement("a", {
      key: locale,
      onClick: onClick
    }, name, React.createElement(DisclosureArrow, {
      className: "LocaleSwitcher__arrow",
      svgClassName: "LocaleSwitcher__arrow__svg"
    }));
  }
};
LocaleSwitcher.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string,
  children: PropTypes.func,
  hideModal: PropTypes.func,
  showModal: PropTypes.func,
  updateAccountLocale: PropTypes.func.isRequired
};